// バックエンドエラーメッセージ → i18n キー のマッピング
export const backendErrorMessages = {
  The_domain_name_may_not_be_set_to_null: "backend.error.domain_name_null",
  Must_provide_a_domain_names: "backend.error.must_provide_domain_name",
  The_domain_names_format_is_invalid: "backend.error.domain_name_format_invalid",
  The_companyName_may_not_be_set_to_null: "backend.error.company_name_null",
  Must_provide_a_companyName: "backend.error.must_provide_company_name",
  The_companyPassword_may_not_be_set_to_null: "backend.error.company_password_null",
  Must_provide_a_company_password: "backend.error.must_provide_company_password",
  The_eaName_may_not_be_set_to_null: "backend.error.ea_name_null",
  Must_provide_a_eaName: "backend.error.must_provide_ea_name",
  The_eaPassword_may_not_be_set_to_null: "backend.error.ea_password_null",
  Must_provide_eaPassword: "backend.error.must_provide_ea_password",
  The_company_is_already_exist: "backend.error.company_already_exist",
  The_company_is_not_exist: "backend.error.company_not_exist",
  The_companyPassword_is_wrong: "backend.error.company_password_wrong",
  The_eaName_is_wrong: "backend.error.ea_name_wrong",
  The_eaPassword_is_wrong: "backend.error.ea_password_wrong",
};

/**
 * バックエンドエラーメッセージを i18n キーに変換する
 * @param {string} message - バックエンドから返ってきた errorMessage
 * @param {string} fallbackKey - マッピングがない場合のデフォルトキー
 * @returns {string} i18n キー
 */
export const resolveBackendErrorKey = (message, fallbackKey = "auth.error.signin") => {
  return backendErrorMessages[message] || fallbackKey;
};
